export default "__VITE_ASSET__c178928d__"